var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-wrapper"},[_c('Navbar'),_c('BreadCrumb',{attrs:{"title":"Career","desc":"What’s the best thing about working at CloudTech? Easy. The people."}}),_c('Jobs'),_c('WhyJoin'),_c('FooterWithBg')],1)}
var staticRenderFns = []

export { render, staticRenderFns }